module.exports = __webpack_public_path__ + "static/media/mobile-01.f7ba34d8.png";